module.exports = __webpack_public_path__ + "static/img/order_end.bcfc48a2.png";